import React, { useState, useEffect } from "react";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import CatalogFilterSection from "../../components/CatalogPage/CatalogFilterSection";
import CatalogProduct from "../../components/CatalogPage/CatalogProduct";
import CatalogProductSorting from "../../components/CatalogPage/CatalogProductSorting";
import {
  appGetCategoryDetails,
  appGetFilters,
} from "../../services/CatalogServices";
import {
  LS_CAT_PRODS_KEY,
  sortOrderOptions,
} from "../../utils/Constant";
import Header from "../../components/Header/Header";
import MobileCatalogSort from "../../components/CatalogPage/MobileCatalogSort";
import MobileCatalogFilter from "../../components/CatalogPage/MobileCatalogFilter";
/**
 * BOC
 * Support#138967-Filters Logic
 * author Maanik Arya
 * date 21-Jun-2023
 * use_of_code:- Import the MobileCatalogTopFilter component.
 */
import MobileCatalogTopFilter from "../../components/CatalogPage/MobileCatalogTopFilter";
/**EOC */

import "./ProductCatalog.css";
import ProductListPlaceholder from "../../components/Placeholders/Templates/ProductListPlaceholder";
import Placeholder from "../../components/Placeholders/Placeholder";
import useScroll from "../../hooks/useScroll";
import {
  decodeFiltersFromQueryString,
  // encodeFiltersForQueryString,
} from "../../utils/UtilityMethod";
// import useElementOnScreen from '../../hooks/useElementOnScreen';

// import InfiniteScroll from "react-infinite-scroll-component";
import { useParams, useSearchParams } from "react-router-dom";
import useMobileDevice from "../../hooks/useMobileDevice";
import {categoryPageEventsFB} from "../../utils/PixelEvents/FacebookEvents";
import {GoogleCategoryPageEvents} from "../../utils/PixelEvents/GoogleEvents";
import { useNavigate } from 'react-router-dom';
import Loader from "../../utils/Loader/CategoryLoader";
import InfiniteScroll from "react-infinite-scroller";
// import { useCallback } from "react";

function ProductCatalog() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  // Get category id from url
  const { '*':categoryId } = useParams() || "";

  const [headingTitle, setHeadingTitle] = useState("");
  const [products, setProducts] = useState([]);
  const [filters, setFilters] = useState([]);
  const [totalProductCount, setTotalProductCount] = useState(0);
  // const [catId, setCatId] = useState(null);
  const [pageSize] = useState(30);
  const [showProdSkeleton, setShowProdSkeleton] = useState(false);
  const [loaderStatus, setloaderStatus] = useState(localStorage.getItem(LS_CAT_PRODS_KEY) ? true : false);
  // const [prodSkeletonSize, setprodSkeletonSize] = useState(
  //   localStorage.getItem(LS_CAT_PRODS_KEY)
  //     ? JSON.parse(JSON.parse(localStorage.getItem(LS_CAT_PRODS_KEY)).cp).length
  //     : 6
  // );
  const [prodSkeletonSize,setprodSkeletonSize] = useState(6);
  const [filterLoading, setFilterLoading] = useState(false);
  const [responseBreadcrumbs, setresponseBreadcrumbs] = useState();

  const [isScroll] = useScroll();

  // Infinite Scroll
  const [hasMore, setHasMore] = useState(true);
  const [initialScrollY, setInitialScrollY] = useState(0);
  // const [infiniteScrollY, setinfiniteScrollY] = useState(0);
  const [qsFilters, setQsFilters] = useState("");
  const [categoryURL, setCategoryURL] = useState("");
  
  const [sortOrder, setSortOrder] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    // get query strings
    // let qsFilters = searchParams?.get("f") || "";
    // Added the code to extract category page URL and filter URL on the page
    let categoryIdArr = categoryId?.split("/") || [];
    let attributeIndex = -1;
    categoryIdArr.every(function (value, index) {
      let attributeCodes = ["gender", "age-group", "manufacturer","category","category-type", "size", "discount-percent-range", "summer-winter", "filter-color", "price","product-delivery-timeline","returnable-policy"];
      if (attributeCodes.indexOf(value) !== -1) {
        attributeIndex = index; return false
      }
      else return true;
    });

    setCurrentPageNumber(1);
    if (attributeIndex !== -1) {      
      setCategoryURL(categoryIdArr.slice(0, attributeIndex).join("/"));
      setQsFilters(categoryIdArr.slice(attributeIndex).join("/"));
    } else {
      setCategoryURL(categoryId);      
      setQsFilters('');
    }
    setSortOrder(searchParams?.get("sort-by") || "");
    setSearchTerm(searchParams?.get("search") || "");
  }, [categoryId, searchParams]);
  
  // let sortOrder = searchParams?.get("sort-by") || "";
  // let searchTerm = searchParams?.get("search") || "";
  // let page =
  //   parseInt(searchParams?.get("p")) > 1
  //     ? parseInt(searchParams?.get("p"))
  //     : 1 || 1;

  const [currentPageNumber, setCurrentPageNumber] = useState(1); // track current page number

 const { isMobile } = useMobileDevice();
const [productLine] = useState(isMobile? 15 : 10);
 const [fetching, setFetching] = useState(false);

 useEffect(() => {
  // if(searchTerm !== ""){
  //   setCurrentPageNumber(1);
  //   fetchItems();
  // }else{
    fetchItems();
  // }  
 }, [
    //  currentPageNumber,
     qsFilters,
     pageSize,
     searchTerm,
     sortOrder,
     categoryURL,
 ]);

 const extraDataUpdate = async (objFromDs) => {
  setHasMore(objFromDs.hm || true);
}


 const fetchItems = 
   async () => {
     if (fetching) {
       return;
     }

     setFetching(true);
     
     try {
      setShowProdSkeleton(true);
       const objFromDs =
         JSON.parse(localStorage.getItem(LS_CAT_PRODS_KEY) || "{}") || {};
       const productsFromDs = JSON.parse(objFromDs.cp || "[]") || [];
       const scrollPos = parseInt(objFromDs.sp) || 0;
       if (productsFromDs && productsFromDs.length > 0) {
        await extraDataUpdate(objFromDs);
         return new Promise((resolve, reject) => {
           setInitialScrollY(scrollPos);
           setTotalProductCount(objFromDs.tpc || productsFromDs.length || 0);
           setProducts([...productsFromDs]);
           setHasMore(objFromDs.hm || true);
           setHeadingTitle(objFromDs.t || "");
           setFilters(JSON.parse(objFromDs.fp || "[]") || []);
           setShowProdSkeleton(false);
           resolve(true);
         }).then((result) => {
          // if((productsFromDs.length/30) > currentPageNumber){  
            setCurrentPageNumber(((productsFromDs.length/30)+1)); 
          // }
          // else{
          //   setCurrentPageNumber((p) => ++p);
          // }
          
           window.scrollTo({
             left: 0,
             top: scrollPos || 0,
             behavior: "instant",
           });
           localStorage.removeItem(LS_CAT_PRODS_KEY);
           setprodSkeletonSize(6);
           setloaderStatus(false);
         });
       } else if (categoryURL !== "" || searchTerm !== "") {        
         let decodedFiltersObj = await decodeFiltersFromQueryString(qsFilters);
         let response = await appGetCategoryDetails({
           sort_by: sortOrder,
           item_count: pageSize,
           page_number: currentPageNumber,
           filter: JSON.stringify({ filter_result: decodedFiltersObj }),
           category_url: categoryURL,
           search_term: searchTerm,
         });

         response = JSON.parse(response?.data);
         let productList = response?.fproducts?.products || [];
         let countTotalProduct = response?.fproducts?.total_product_count || 0;
         setTotalProductCount(countTotalProduct);
         setHeadingTitle(response?.fproducts?.title);
         if (currentPageNumber > 1) {
           setProducts((p) => p.concat(productList));
         } else {
           setProducts(productList);
         }
         setCurrentPageNumber((p) => ++p);
         setresponseBreadcrumbs(response?.breadcrumb);
         if (currentPageNumber * pageSize < countTotalProduct) {
           setHasMore(true);
         } else {
           setHasMore(false);
         }
         if(currentPageNumber > 1){
          let height = window.$('.product-margin-mb').height();
          let scrollPosition = (height*(productLine*(currentPageNumber-1)));
          if (scrollPosition && scrollPosition < window.scrollY) {
            window.scrollTo({
              left: 0,
              top: scrollPosition || 0,
              behavior: "instant",
            });
          }
         }

         /**
         * @BOC
         * @Support #157051-Implement Changes On Staging Server Such that Filters are Listed on Category Page from Typesense
         * @author Mohammad Meraj
         * @date 02-Jan-2025
         * @use_of_code: Now, the Category Page functionality has been updated to fetch data from BraveOtter (Typesense), meaning both the products and filters are retrieved from Typesense.
         * The Category API has been modified to include both the product data and the filters. As a result, there is no longer a need to make a separate call to the Filters API to fetch the filters.
         * The code has been updated to first attempt to retrieve the filters directly from the Category API response.If the filters are not present in the Category API response, the page will then fall back to calling the Filters API to ensure the filters are loaded properly.
         */ 
         let filterResponse = {};
          if(response?.filter_result === undefined){
              filterResponse = await appGetFilters({
              // category_url: categoryId,
              category_url: searchTerm? "" : categoryURL,
              search_term: searchTerm,
              filter: JSON.stringify({ filter_result: decodedFiltersObj }),
            });
            filterResponse = JSON.parse(filterResponse?.data);
          }else {
            filterResponse = response;
          }
          /**
           * EOC
           */
         let filtersObj = filterResponse?.filter_result || [];
         setFilters(filtersObj);
         // fix added to show selected filter labels on the desktop
         var arr = window.$("#filter-by-list-items").find(".filter-by-label");
         window.$.each(arr, function (i, val) {
           let filter_label_id = "cbitem-" + val.id;
           let filter_label_text = window
             .$('label[for="' + filter_label_id + '"]')
             .text();
           window
             .$("#darve-filter-label-id" + val.id + "")
             .html(filter_label_text);
         });

        // handling error in try catch block
        try {
          categoryPageEventsFB(response,searchTerm);
        } catch (e) {
          console.log(e.message);
        }
        // handling error in try catch block
        try {
          GoogleCategoryPageEvents(response,searchTerm);
        } catch (e) {
          console.log(e.message);
        }  
        setShowProdSkeleton(false);
        setFilterLoading(false);
       } 
     } finally {
       setFetching(false);
     }
   }
  //  // [items, fetching, nextPageUrl]
  //  [
  //    fetching,
  //    currentPageNumber,
  //    infiniteScrollY,
  //    qsFilters,
  //    pageSize,
  //    searchTerm,
  //    sortOrder,
  //    categoryURL,
  //    products,
  //  ]
  // };


  // This will call the appGetCateogryDetails api.
  // and it is dependent on sortOrder so whenever sortOrder changes then the this api will get called
  // and thus update the product list
  // useEffect(() => {
  //   setShowProdSkeleton(true);
  //   const objFromDs =
  //     JSON.parse(localStorage.getItem(LS_CAT_PRODS_KEY) || "{}") || {};
  //   const productsFromDs = JSON.parse(objFromDs.cp || "[]") || [];
  //   const scrollPos = parseInt(objFromDs.sp) || 0;
  //   if (productsFromDs && productsFromDs.length > 0) {
  //     return new Promise((resolve, reject) => {
  //       setInitialScrollY(scrollPos);
  //       setTotalProductCount(objFromDs.tpc || productsFromDs.length || 0);
  //       setProducts([...productsFromDs]);
  //       setHasMore(objFromDs.hm || true);
  //       setHeadingTitle(objFromDs.t || "");
  //       setFilters(JSON.parse(objFromDs.fp || "[]") || []);
  //       // localStorage.removeItem(LS_CAT_PRODS_KEY);
  //       setShowProdSkeleton(false);
  //       // setCurrentPageNumber((p) => ++p);
  //       resolve(true);
  //     }).then((result) => {
  //       window.scrollTo({ left: 0, top: scrollPos || 0, behavior: "instant" });
  //       localStorage.removeItem(LS_CAT_PRODS_KEY);
  //       setprodSkeletonSize(9);
  //     });
  //   // } else {
  //   } else if (categoryURL !== "" || searchTerm !== "") {
  //     // decode filter query string
  //     setFilterLoading(true);
  //     decodeFiltersFromQueryString(qsFilters).then((decodedFiltersObj) => {  
  //       appGetCategoryDetails({
  //         sort_by: sortOrder,
  //         item_count: pageSize,
  //         page_number: currentPageNumber,
  //         filter: JSON.stringify({ filter_result: decodedFiltersObj }),
  //         // category_url: categoryId,
  //         category_url: categoryURL,
  //         search_term: searchTerm,
  //       })
  //         .then((response) => {
  //           response = JSON.parse(response?.data);
  //           let productList = response?.fproducts?.products || [];
  //           let countTotalProduct =
  //             response?.fproducts?.total_product_count || 0;
  //           setTotalProductCount(countTotalProduct);
  //           setHeadingTitle(response?.fproducts?.title);
  //           // setCurrentPageNumber((p) => ++p);
  //           // console.log(categoryId);
  //           // console.log(categoryURL);
  //           // if (catId === categoryId && currentPageNumber > 1) {
  //           if (currentPageNumber > 1) {  
  //             setProducts((p) => p.concat(productList));
  //           } else {
  //             setProducts(productList);
  //           }
  //           setresponseBreadcrumbs(response?.breadcrumb);
  //           // setCatId(categoryId);
  //           if (currentPageNumber * pageSize < countTotalProduct) {
  //             setHasMore(true);
  //           } else {
  //             setHasMore(false);
  //           }

  //           // Get Filters details
  //           decodeFiltersFromQueryString(qsFilters).then((decodedFiltersObj) => {
  //             appGetFilters({
  //               // category_url: categoryId,
  //               category_url: categoryURL,
  //               search_term: searchTerm,
  //               filter: JSON.stringify({ filter_result: decodedFiltersObj }),
  //             }).then((response) => {
  //               response = JSON.parse(response?.data);
  //               let filtersObj = response?.filter_result || [];
  //               setFilters(filtersObj);
  //               // fix added to show selected filter labels on the desktop
  //               var arr = window.$("#filter-by-list-items").find('.filter-by-label');
  //               window.$.each(arr, function (i, val) {
  //                 let filter_label_id = "cbitem-" + val.id;
  //                 let filter_label_text = window.$('label[for="' + filter_label_id + '"]').text();
  //                 window.$('#darve-filter-label-id' + val.id + '').html(filter_label_text);
  //               });
  //               // setFilterLoading(false);
  //             });
  //           });
  //           categoryPageEventsFB(response);
  //           if(infiniteScrollY && infiniteScrollY< window.scrollY){
  //             window.scrollTo({ left: 0, top: infiniteScrollY || 0, behavior: "instant" });
  //           }
  //         })
  //         .finally(() => {
  //           setShowProdSkeleton(false);
  //           setFilterLoading(false);
  //         });
  //     });
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [
  //   currentPageNumber,
  //   qsFilters,
  //   pageSize,
  //   searchTerm,
  //   sortOrder,
  //   categoryURL
  // ]);

  // const fetchProductData = () => {
  //   let height = window.$('.product-margin-mb').height();
  //   if((products.length/30) > currentPageNumber){
  //     setinfiniteScrollY(height*(15*(products.length/30)));
  //     console.log("test")
  //     setCurrentPageNumber(((products.length/30)+1));  
  //   }else{
  //     setinfiniteScrollY(height*(15*currentPageNumber));
  //     setCurrentPageNumber((p) => ++p);
  //     console.log("test1")
  //   }
  // };

  // Here, we are setting the local state of sortOrder.
  const handleSortOrderCallback = (sort_by) => {
    searchParams.set("sort-by", sort_by);

    //Each time sort by changes,  the current page number will be updated to 1 and products will be empty and total product count will be 0
    setCurrentPageNumber(1);
    setProducts([]);
    setTotalProductCount(0);
    if (searchParams.has("p")) {
      searchParams.delete("p");
    }
    setSearchParams(searchParams);

  };

  // Checkbox callback method to get data and checked status
  const cbCallback = (filterDataArr) => {
    let sub_url = '';
    // Added the code to sort the attributes based on sort order
    const sorter = (a, b) => {
      return a.sort_order - b.sort_order;
    };
    const sortByOrder = arr => {
      arr.sort(sorter);
    };
    sortByOrder(filterDataArr);
    filterDataArr.forEach(function (filterData) {
      let attribute_code = '';
      let filter_label = '';
      attribute_code = filterData.title.replace("id_attribute_group|", "");
      /* eslint-disable */
      attribute_code = attribute_code.replace(/\_/g, "-");
      let items = filterData.items;
      items.forEach(function (item, index) {
        // let name = item.name.toLowerCase();
        // let id = item.id;
        let url_slug = item.url_slug;
        if (index > 0) {
          // filter_label = filter_label.concat("__" + name + "_" + id);
          filter_label = filter_label.concat("--" + url_slug);
        } else {
          // filter_label = name;
          // filter_label = name + "_" + id;
          filter_label = url_slug;
        }
        /* eslint-disable */
        filter_label = filter_label.replace(/\ /g, "-");
        filter_label = filter_label.replace(/\(/g, "");        
        filter_label = filter_label.replace(/\)/g, "");
        filter_label = filter_label.replace(/\&/g, "+");
        filter_label = filter_label.replace(/\'/g, "");
        filter_label = filter_label.replace(/\%/g, "");
        filter_label = filter_label.replace(/\./g, "");
        filter_label = filter_label.replace(/\%/g, "");
        filter_label = filter_label.replace(/\//g, "");
      });
      sub_url = sub_url.concat("/" + attribute_code + "/" + filter_label);
    });
    setCurrentPageNumber(1);
    setQsFilters(sub_url.substring(1));
      //Each time any filter is applied, the current page number will be updated to 1 and total product count will be 0

    
    setProducts([]);
    setTotalProductCount(0);
    if (searchParams.has("p")) {
      searchParams.delete("p");
    }    
    setSearchParams(searchParams);
    // Added the condition for sort by
    // Fix added for search page filter issue
    // Added the condition for seach page
    if (searchParams.has("sort-by") && searchParams.has("search")) {
      sub_url = sub_url.concat("?search=" + searchParams.get("search") + "&sort-by=" + searchParams.get("sort-by"));
    }
    else if (searchParams.has("search")) {
      sub_url = sub_url.concat("?search=" + searchParams.get("search"));
    }
    else if (searchParams.has("sort-by")) {
      sub_url = sub_url.concat("?sort-by=" + searchParams.get("sort-by"));
    }
    if (searchParams.has("search")) {
      return navigate("/catalog" + sub_url);
    } else {
      return navigate("/catalog/" + categoryURL + sub_url);
    }
  };

  const updateWishlistProductStatus = (product_id, wishlist_status) => {    
    products.map((product) => {
      return (
        <>
          {product.id === product_id ? product.is_in_wishlist = !wishlist_status : ""}
        </>

      );      
    });  
    saveProductsCb();
  }

  const saveProductsCb = () => {
    return new Promise((resolve, reject) => {
      const dataToSave = JSON.stringify(products);
      const filterdataToSave = JSON.stringify(filters);
      let scrollPos = window.scrollY;
      localStorage.setItem(
        LS_CAT_PRODS_KEY,
        JSON.stringify({
          // sp: scrollPos + 100,
          sp: scrollPos,
          cp: dataToSave,
          tpc: totalProductCount,
          t: headingTitle,
          hm: hasMore,
          fp: filterdataToSave,
        })
      );
      resolve(true);
    });
  };

  const hasMoreItems = !!hasMore;

  return (
    <>
      {/* Header */}
      <Header
        mobileHeaderOptions={{
          menuIcon: false,
          wishlistIcon: false,
          rightWishlistIcon: true,
          darveysLargeTextIcon: false,
          searchIcon: true,
          shoppingBagIcon: true,
          backButtonIcon: true,
          pageHeadingShow: true,
          pageHeadingText: headingTitle || "",
          darveysSmallIcon: true,
          userAccountIcon: true,
          headerNotSticky: true,
        }}
      />
      <div className="clearfix"></div>

      {/* Mobile Sorting and Filter Section */}
      {isMobile && (
        <div
          className={`filter-section mobile-display mobile-header p-0 ${
            isScroll ? " sticky " : ""
          }`}
        >
          <div className="container-fluid">
            <div className="row">
              {showProdSkeleton ? (
                <>
                  {/* Mobile Sorting Section 
                  /**
                  * BOC
                  * Support#138967-Filters Logic
                  * author mohammad Meraj
                  * date 18-July-2023
                  * use_of_code:- updated the code for fix the design issue of the filter placeholder.
                  */}
                  <div className="col-12 ml-auto">
                    <Placeholder
                      variant="rectangular"
                      width="100%"
                      height="40px"
                      style={{ marginLeft: "auto" }}
                    />
                  </div>
                  {/* Mobile Filter Section */}
                  {/* <div className="col-6">
                    <Placeholder
                      variant="rectangular"
                      width="60px"
                      height="25px"
                    />
                  </div> */}
                </>
              ) : (
                <>
                  {/* Mobile Top Filter Section */}
                  {   
                  /**
                   * BOC
                   * Support#138967-Filters Logic
                   * author Maanik Arya
                   * date 21-Jun-2023
                   * use_of_code:- The MobileCatalogTopFilter component is used to display the Top filter section on the mobile as per the requirement given by client.
                   * The cbCallback is used to handle the filter functionality.
                   * The filters is used to store the filters data.
                   * The filterQs is used to store the filter query string.
                   * The sortOptions is used to store the sort options.
                   * The sortCallback is used to handle the sort functionality.
                   * The searchParams is used to store the search params.
                   * Also Commented the Exiting Mobile Sorting Section and Mobile Filter Section.
                   */
                  }
                  <div>
                  <MobileCatalogTopFilter 
                    cbCallback={cbCallback}
                    filters={filters}
                    filterQs={qsFilters}
                    sortOptions={sortOrderOptions}
                    sortCallback={handleSortOrderCallback}
                    searchParams={searchParams}
                  />
                  </div>
                  {/* Mobile Sorting Section */}
                  {/* <div className="col-6 text-right pr-30px">
                    <MobileCatalogSort
                      sortOptions={sortOrderOptions}
                      sortCallback={handleSortOrderCallback}
                      searchParams={searchParams}
                    />
                  </div> */}
                  {/* Mobile Filter Section */}
                  {/* <div className="col-6 pl-30px">
                    <MobileCatalogFilter
                      cbCallback={cbCallback}
                      filters={filters}
                      searchParams={searchParams}
                      filterQs={qsFilters}
                    />
                    <span style={{marginLeft:"5px",fontSize:"11px"}} hidden='hidden'>{totalProductCount ? " ("+totalProductCount+" items)" : ""}</span>
                  </div> */}
                  {/** EOC */}
                </>
              )}
              {/* <span style={{textAlign:"right",marginTop:"-24px",fontSize:"11px"}}>{totalProductCount ? " ("+totalProductCount+" items)" : ""}</span> */}
            </div>
          </div>
        </div>
      )}

      <div className="clearfix"></div>
      {/* Breadcrumb Section */}
      <section className="breadcrumb-heading spacer desktop-display">
        <div className="container-fluid">
          {showProdSkeleton ? (
            <div className="row">
              <div className="col-md-3">
                <Placeholder variant="text" />
              </div>

              <div className="col-md-6">
                <div className="main-heading-center">
                  <h3>
                    <Placeholder
                      variant="text"
                      width="50%"
                      className="mx-auto"
                    />
                  </h3>
                </div>
              </div>

              <div className="col-md-3">
                <Placeholder
                  variant="rectangular"
                  height="35px"
                  width="60%"
                  style={{ marginLeft: "auto", marginRight: "0" }}
                />
              </div>
            </div>
          ) : (
            <div className="row">
              <div className="col-md-4">
                {/* <Breadcrumb
                  breadcrumbs={[
                    ...breadcrumbs,
                    { title: headingTitle, active: true },
                  ]}
                  isLoading={showProdSkeleton}
                /> */}
                <Breadcrumb
                  breadcrumbs={responseBreadcrumbs || []}
                  isLoading={showProdSkeleton}
                />
              </div>

              <div className="col-md-5">
                <div
                  className="main-heading-center"
                  style={{
                    textAlign: isMobile ? "" : "left",
                    marginLeft: isMobile ? "" : "170px",
                  }}
                >
                  <h1 style={{float: "left"}}>{headingTitle}</h1>&nbsp;<span style={{fontSize:"13px"}}>{(totalProductCount && !isMobile) ? "("+totalProductCount+" items)" : ""}</span>
                </div>
              </div>

              {/* Sorting */}
              {!isMobile && (
                <div className="col-md-3">
                  <CatalogProductSorting
                    sortOptions={sortOrderOptions}
                    sortCallback={handleSortOrderCallback}
                  />
                </div>
              )}
            </div>
          )}
        </div>
      </section>

      <div className="clearfix"></div>
      {/* Filter and Catalog list */}
      <div className="catalogue-section">
        <div className="container-fluid">
          <div className="row">
            {/* Filter Section */}
            {!isMobile && (
              <div
                className={`col-md-3 desktop-display ${
                  isScroll ? " sticky " : ""
                }`}
              >
                {filterLoading ? (
                  <>
                    <Placeholder variant="rectangular" height="600px" />
                  </>
                ) : (
                  <CatalogFilterSection
                    cbCallback={cbCallback}
                    filters={filters}
                    searchParams={searchParams}
                    filterQs={qsFilters}
                  />
                )}
              </div>
            )}

            {/* /Filter */}

            {/* Product List Section */}
            <div
              className={`col-lg-9 ${isScroll ? " sticky-right-column " : ""}`}
            >
              <div className="">
                {loaderStatus ? 
                  <Loader/>  
                  :
                  ""
                }
                {/* <InfiniteScroll
                  className="row"
                  dataLength={products.length}
                  next={() => {
                    fetchProductData();
                  }}
                  hasMore={hasMore}
                  initialScrollY={initialScrollY}
                  loader={
                    <>
                      {(prodSkeletonSize<10) ? 
                      Array.from(Array(prodSkeletonSize), (e, i) => {
                        return <ProductListPlaceholder key={i} />;
                      })
                      :
                      <Loader/>
                      }
                    </>
                  }
                > */}

                <InfiniteScroll
                  pageStart={initialScrollY}
                  className="row"
                  // dataLength={products.length}
                  loadMore={fetchItems}
                  hasMore={hasMore}
                  // initialScrollY={initialScrollY}
                  loader={!products.length?                    
                      Array.from(Array(prodSkeletonSize), (e, i) => {
                        return <ProductListPlaceholder key={i} />;
                      })
                      :
                      <div style={{justifyContent:'center',display:'flex',marginTop:"25px"}}>
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/icons/loader.gif"
                        }
                        alt=""
                        style={{width:isMobile? "15%":"50px",height:isMobile? "100%":""}}
                      />
                      </div>
                  }
                >
                  {products.length
                    ? products.map((product, index) => {
                        return (
                          <CatalogProduct
                            key={`prod-${product.id}-${index}`}
                            product={product}
                            saveProductsCb={saveProductsCb}
                            updateWishlistProductStatus={
                              updateWishlistProductStatus
                            }
                          />
                        );
                      })
                    : 
                    // <div className="no_products" style={{textAlign:"center"}}>No Products for this category! </div>
                    // <div className="no_products" style={{textAlign:"center"}}>No Products available as per your selection. </div>
                    ""
                  }
                </InfiniteScroll>
              </div>
            </div>
            {/* /Product List */}
          </div>
        </div>
      </div>
    </>
  );
}

export default ProductCatalog;
